<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <MerchantTotalSales />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div>
  </div>
</template>

<script>
import MerchantTotalSales from "./MerchantTotalSales";
import ProjectsTable from "../components/ProjectsTable";

export default {
  name: "tables",
  components: {
    MerchantTotalSales,
    ProjectsTable,
  },
};
</script>
